import { Button } from '@material-ui/core'
import React, { FC } from 'react'
import styles from './ConfirmPlace.module.scss'
import { useI18n } from 'utils/i18n/hooks/useI18n';
export interface IConfirmPlaceProps {
    //propertys
    onClickConfirmar: () => void,
    onClickVoltar: () => void,
    table?: string;
}
const ConfirmPlace: FC<IConfirmPlaceProps> = ({ onClickConfirmar, onClickVoltar, table }) => {
    const { t } = useI18n();
    
    return (
        <div id={styles.ConfirmPlace} >
            <h2 >
                {t("payment.confirmation.placeConfirmation")}
            </h2>
            <span  >
                {t("payment.confirmation.confirmOrderPlace")} <b>{table}</b>
            </span>
            <Button color='primary' variant='contained' onClick={onClickConfirmar}>{t("payment.buttons.confirm")}</Button>
            <Button color='primary' variant='outlined' onClick={onClickVoltar}>{t("payment.buttons.back")}</Button>
        </div>
    )
}
export default ConfirmPlace